import { fetchAuthSession, signOut } from "aws-amplify/auth";
import { useEffect, useState } from "react";
import { Button } from "manifest-components/src/Button";

import { RoutePaths, useTypedNavigate } from "../../../routes/RoutePaths";
import PageLayout from "../../../components/PageLayout";

const Auth = () => {
  const [user, setUser] = useState<string>("");
  const navigate = useTypedNavigate();

  useEffect(() => {
    const init = async () => {
      const sessionRes = await fetchAuthSession();
      console.log({ sessionRes });
      if (sessionRes.tokens?.idToken?.payload.given_name) {
        setUser((sessionRes.tokens?.idToken?.payload.given_name as string) || "");

        // NOTE: We can check here whether user has phone_number in Cognito from idToken.payload.phone_number, but the accessToken does not allow frontend to fetchUserAttributes and updateUserAttributes
      }
    };
    init();
  }, []);

  const onClickSignOut = async () => {
    const currentOrigin = window.location.origin;
    console.log({ currentOrigin });

    const domain = "us-east-1mp8uatdqm.auth.us-east-1.amazoncognito.com";
    const clientId = "5quri628chnvusj1oiue0qr873";
    window.location.href = `https://${domain}/logout?client_id=${clientId}&logout_uri=${encodeURIComponent(
      `${currentOrigin}/`
    )}`;
  };

  return (
    <PageLayout>
      Hi {user}
      <Button name="signOut" text="Sign out" onClick={onClickSignOut} />
    </PageLayout>
  );
};

export default Auth;
